import type { ReactNode } from 'react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { cn } from '@/shared/lib/utils'
import { useNotifications } from './notification-store'

export function NotificationProvider({ children }: { children: ReactNode }) {
  const { items } = useNotifications()

  const variantStyles = {
    success: {
      alert: 'bg-chart-2/15 text-foreground',
      title: 'text-chart-2',
    },
    error: {
      alert: 'bg-destructive/15 text-foreground',
      title: 'text-destructive',
    },
    info: {
      alert: 'bg-chart-3/15 text-foreground',
      title: 'text-chart-3',
    },
    destructive: {
      alert: 'bg-destructive/15 text-foreground',
      title: 'text-destructive',
    },
  } as const

  return (
    <>
      {children}
      <div className="pointer-events-none fixed bottom-4 left-4 z-50 flex w-[320px] flex-col gap-2">
        {items.map((item) => {
          const styles = variantStyles[item.variant]
          return (
            <Alert
              key={item.id}
              className={cn(
                'pointer-events-auto border-none shadow-md backdrop-blur',
                styles.alert,
              )}
            >
              <AlertTitle className={styles.title}>{item.title}</AlertTitle>
              {item.description ? (
                <AlertDescription>{item.description}</AlertDescription>
              ) : null}
            </Alert>
          )
        })}
      </div>
    </>
  )
}
